<p-menubar
  [model]="isWorkshopMode ? [] : menuBarItems"
  [autoDisplay]="false"
  [styleClass]="getMenuBarClasses()">
  <ng-template pTemplate="start">
    <div class="flex gap-2 align-items-center">
      <p-button
        (click)="goToLandingpage()"
        [rounded]="true"
        icon="fas fa-home"></p-button>
      @if (isWorkshopMode) {
        <button
          pButton
          (click)="templatePanel.toggle($event)"
          [rounded]="true"
          [outlined]="true"
          pTooltip="Vorlagen"
          icon="fas fa-shapes"></button>

        <span
          class="flex align-items-center gap-2 text-color-secondary text-sm font-medium px-2">
          <i class="fas fa-screwdriver-wrench"></i>
          {{ isGridEmpty ? 'Werkstatt - wähle eine Vorlage' : 'Werkstatt' }}
        </span>
        <p-overlayPanel
          #templatePanel
          [showCloseIcon]="true"
          styleClass="topic-flyout-panel sm:w-45rem md:w-60rem lg:w-75rem border-round-2xl mr-8">
          <div class="flex flex-column gap-3 p-1">
            <app-header icon="fas fa-shapes" text="Vorlagen"></app-header>
            @if (!isGridEmpty) {
              <div
                class="flex align-items-center gap-2 text-color-secondary text-sm px-1">
                <i class="fas fa-triangle-exclamation"></i>
                Eine Vorlage ersetzt die aktuelle Ansicht.
              </div>
            }
            <p-divider styleClass="my-0"></p-divider>
            <div class="grid overflow-y-auto -mt-2" style="max-height: 36rem">
              @for (template of templateService.templates; track template.key) {
                <div class="col-12 sm:col-6 lg:col-4">
                  <div
                    class="topic-flyout-section h-full p-3 border-round-xl flex flex-column gap-2 cursor-pointer"
                    (click)="selectTemplate(template.key, templatePanel)">
                    <div class="flex align-items-center gap-3">
                      <span
                        class="bg-primary flex align-items-center justify-content-center text-white border-circle w-3rem h-3rem flex-shrink-0 shadow-2">
                        <i [class]="template.icon"></i>
                      </span>
                      <span class="font-bold text-lg">{{
                        template.label
                      }}</span>
                    </div>
                    <div class="text-color-secondary">
                      {{ template.description }}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </p-overlayPanel>
      }
      @if (!isWorkshopMode && topicSections.length > 0) {
        <button
          pButton
          (click)="topicPanel.toggle($event)"
          [rounded]="true"
          pTooltip="Themen & Themenbereiche"
          [class]="getTopicButtonClasses()"
          [icon]="
            globalStore.activeTopic()
              ? 'fas fa-' + globalStore.activeTopic()!.icon
              : 'fas fa-compass'
          "></button>

        <p-overlayPanel
          #topicPanel
          [showCloseIcon]="true"
          styleClass="topic-flyout-panel sm:w-45rem md:w-60rem lg:w-75rem border-round-2xl mr-8">
          <div class="flex flex-column gap-3 p-1">
            <app-header
              icon="fas fa-compass"
              text="Themen &amp; Themenbereiche!"></app-header>
            <p-divider styleClass="my-0"></p-divider>
            <div class="grid overflow-y-auto -mt-2" style="max-height: 36rem">
              @for (section of topicSections; track section.topic._id) {
                <div class="col-12 sm:col-6 lg:col-4">
                  <div
                    class="topic-flyout-section h-full p-3 border-round-xl flex flex-column gap-2">
                    <div
                      class="flex align-items-center gap-3 cursor-pointer"
                      (click)="selectTopic(section.topic, topicPanel)">
                      <span
                        class="flex align-items-center justify-content-center text-white border-circle w-3rem h-3rem flex-shrink-0 shadow-2"
                        [ngClass]="getSectionBadgeClasses(section.topic)">
                        <i [class]="'fas fa-' + section.topic.icon"></i>
                      </span>
                      <span class="font-bold text-lg">{{
                        section.topic.title
                      }}</span>
                    </div>
                    <ul class="list-none p-0 m-0 flex flex-column gap-1">
                      @for (
                        category of section.categories;
                        track category._id
                      ) {
                        <li>
                          <a
                            class="topic-flyout-item flex align-items-center justify-content-between gap-2 p-2 border-round-lg text-color no-underline cursor-pointer"
                            (click)="
                              selectCategory(
                                section.topic,
                                category,
                                topicPanel
                              )
                            ">
                            <span class="flex align-items-center gap-2">
                              <i
                                class="fas fa-layer-group text-color-secondary"></i>
                              {{ category.title }}
                            </span>
                            <i
                              class="fas fa-chevron-right text-xs text-color-secondary"></i>
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              }
            </div>
          </div>
        </p-overlayPanel>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="item" let-item>
    <a
      class="flex align-items-center p-menuitem-link gap-2 py-2 px-2 mr-1 border-round-xl transition-colors transition-duration-200"
      [routerLink]="item.routerLink || null"
      [routerLinkActive]="'p-menuitem-link-active font-bold'"
      [pTooltip]="item.pTooltip">
      @if (item.icon) {
        <span [class]="item.icon" class="text-lg"></span>
      }
      <span class="p-menuitem-text font-medium text-sm">{{ item.label }}</span>
      @if (item.items && item.items.length > 0) {
        <i class="fas fa-chevron-down text-xs ml-1 opacity-50"></i>
      }
    </a>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="justify-content-end flex flex-1 align-items-center gap-2">
      <app-atlas-search></app-atlas-search>
      @if (
        activeUserStore.context() !== 'atlasExternal' &&
        activeUserStore.canAccessEntityAdder()
      ) {
        @for (item of topItems; track $index) {
          <p-splitButton
            class="sm:flex hidden"
            [rounded]="true"
            [raised]="true"
            [text]="true"
            size="small"
            styleClass="surface-0"
            [icon]="item.icon"
            (onClick)="quickSave()"
            [model]="item.items">
            <ng-template pTemplate="dropdownicon">
              <i class="fas fa-chevron-down"></i>
            </ng-template>
          </p-splitButton>
        }
      }

      <app-theme-switcher></app-theme-switcher>

      <app-active-user-avatar
        size="large"
        [icon]="
          activeUserStore.context() === 'atlasExternal'
            ? 'fas fa-earth-europe'
            : 'fas fa-house-user'
        "
        [addBookmarks]="true"
        [extraItems]="miscItems"
        [styleClass]="'bg-primary'"></app-active-user-avatar>
    </div>
  </ng-template>
</p-menubar>
<p-confirmDialog key="overwriteBookmark" #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-floppy-disk"
        [text]="message.header"></app-header>

      <div class="flex">
        Ihre Ansicht wird mit der aktuellen Ansicht überschrieben.
      </div>

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          icon="fas fa-check"
          label="ja, fortfahren"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-dialog [modal]="true" [(visible)]="infoVisible" [style]="{ width: '60rem' }">
  <ng-template pTemplate="header">
    <app-header
      icon="fas fa-info-circle"
      [text]="'Willkommen im Kommunal-Atlas!'"
      styleClass="m-0"></app-header>
  </ng-template>

  <p>Liebe Nutzer:innen,</p>

  <p>
    der Kommunal-Atlas bietet Ihnen die Möglichkeit, kommunale Daten interaktiv,
    übersichtlich und individuell aufzubereiten. Kleinräumige Analysen,
    Zeitvergleiche und verschiedene Darstellungsformen helfen Ihnen dabei,
    Entwicklungen und Zusammenhänge schnell zu erkennen.
  </p>
  <p>
    Über die obere Menüleiste gelangen Sie zu verschiedenen Themenbereichen. Mit
    dem Jahres-Slider können Sie Zeiträume vergleichen und so Trends sichtbar
    machen. Der Nachtmodus (aktivierbar über das Mond-Icon
    <i class="fas fa-moon"></i> oben rechts) sorgt bei Bedarf für eine
    augenschonende Darstellung.
  </p>
  <p>
    Nutzen Sie die Suchleiste daneben, um gezielt nach Indikatoren,
    (Teil-)Räumen, Standorten, Ansichten, Berichten oder Themen zu suchen und
    sich die passenden Inhalte anzeigen zu lassen.
  </p>
  <p>
    Ein Highlight ist der Bereich „Erstellen“, den Sie über das Haus-Icon oben
    links auf der Startseite erreichen. Hier können Sie ganz flexibel eigene
    Ansichten gestalten – zum Beispiel mit Kreisdiagrammen, Liniendiagrammen
    oder Tabellen – und diese individuell anpassen.
  </p>
  <p>
    Im rechten unteren Bildschirmbereich finden Sie zwei weitere hilfreiche
    Funktionen. Mit dem Klemmbrett-Icon
    <i class="fa-clipboard-list"></i> erstellen Sie Vergleichsberichte, in denen
    Sie Icon Teilräume oder Standorte über alle Indikatoren hinweg
    gegenüberstellen können.
  </p>
  <p>
    Das Stift-Icon <i class="fas fa-pen"></i> erlaubt es Ihnen, eine bestehende
    Ansicht direkt zu bearbeiten – etwa die Größe von Diagrammen zu verändern
    oder eigene Diagramme hinzuzufügen.
  </p>

  <p>Viel Freude beim Erkunden, Vergleichen und Gestalten!</p>

  <app-header
    styleClass="mt-6"
    text="Die wichtigsten Funktionen im Überblick:"></app-header>

  <p>
    Daten, auch der nicht aufbereiteten, stehen Ihnen die „Suche“ und der
    „Erstellen“-Button zur Verfügung. Hier finden Sie alle Daten der Kommune und
    können Ihre eigenen Diagramme und Berichte erstellen.
  </p>

  <app-header styleClass="mt-6" text="Zurück zur Startseite"> </app-header>
  <p>
    Ein Klick auf das Haus-Icon bringt Sie jederzeit zurück zur Startseite des
    Kommunal-Atlas.
  </p>

  <app-header styleClass="mt-6" text="Wo bin ich gerade?"></app-header>
  <p>
    Oben links neben dem Haus-Icon sehen Sie das Symbol des Themas, in dem Sie
    sich aktuell befinden (sofern angelegt). Ein Klick darauf öffnet ein
    praktisches Dropdown-Menü, das Ihnen alle Themen und Themenbereiche anzeigt
    – so können Sie sich bequem durch den Atlas bewegen.
  </p>

  <app-header styleClass="mt-6" text="Navigation oben"></app-header>

  <p>
    Die Navigation am oberen Bildschirmrand besteht aus einzelnen Dropdowns und
    führt Sie schnell zu verschiedenen Themenbereichen oder in die Teilräume der
    Kommune (sofern angelegt). Hier können Sie sich durch die Inhalte klicken
    und neue Daten entdecken.
  </p>

  <app-header
    styleClass="mt-6"
    text="Zeitvergleiche mit dem Jahres-Slider"></app-header>
  <p>
    Nutzen Sie den Jahres-Slider, um verschiedene Jahre miteinander zu
    vergleichen und Entwicklungen sichtbar zu machen (sofern aktiviert).
  </p>

  <app-header styleClass="mt-6" text="Gezielte Suche"></app-header>
  <p>
    In der Suchleiste oben rechts können Sie gezielt nach Indikatoren,
    (Teil-)Räumen, Standorten, Ansichten, Berichten oder Themen suchen – und
    sich genau die Informationen anzeigen lassen, die Sie interessieren.
  </p>

  <app-header
    styleClass="mt-6"
    text="Weitere Funktionen unten rechts"></app-header>

  <p>
    Im rechten unteren Bereich des Bildschirms finden Sie weitere nützliche
    Tools:
  </p>
  <p>
    Mit dem Klemmbrett-Icon <i class="fas fa-clipboard-list"></i> erstellen Sie
    Vergleichsberichte, in denen Sie beliebige Teilräume oder Standorte über
    alle Indikatoren hinweg miteinander vergleichen können.
  </p>
  <p>
    Über das Werkzeug-Icon <i class="fas fa-wrench"></i> die Ansicht leeren und
    von vorne beginnen.
  </p>

  <p>
    Mit dem Stift-Icon <i class="fas fa-pen"></i> bearbeiten Sie die aktuelle
    Ansicht: Passen Sie z. B. die Größe von Diagrammen an oder fügen Sie eigene
    Diagramme hinzu.
  </p>

  <app-header styleClass="mt-6" text="Im Bearbeitungs-Modus"></app-header>
  <p>
    Über das Plus-Icon <i class="fas fa-plus-circle"></i> fügen Sie eine neue
    Darstellung hinzu.
  </p>
  <p>
    Über das Augen-Icon <i class="fas fa-eye"></i> wechseln Sie wieder in den
    Lese-Modus.
  </p>
</p-dialog>
